import PageApp from './app';

PageApp.brand = 'mcom';

export default PageApp;



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/app-mcom.js